import React from 'react';
import StockIndicator from '@hpstellar/core/StockIndicator';

import InventoryMessage from './inventory-message';

const ProductStatusBadge = ({ product, displayShipMessage, ...otherProps }) => {
    return (
        <InventoryMessage product={product} showOOS={true}>
            {({ stock, shippingMsg, price }) => {
                const { shipMessage: defaultShippingMessage } = product;
                const deliveryMessage = displayShipMessage ? shippingMsg || defaultShippingMessage : null;
                const { stockMessage, stockStatus } = price;
                if (!stockMessage) return <div className="spacer" />;

                return (
                    <StockIndicator
                        color={stockStatus}
                        stockMessage={stockMessage}
                        deliveryMessage={deliveryMessage}
                        size={deliveryMessage ? 'large' : 'small'}
                        {...otherProps}
                    />
                );
            }}
        </InventoryMessage>
    );
};

export default ProductStatusBadge;
